import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserRoleViewModel } from '../../../business-entities/user-role-view-model';
import { UserViewModel } from '../../../business-entities/user-view-model';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { ReceptionService } from '../../../business-services/reception.service';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from '../../../business-services/setting.service';

@Component({
  selector: 'app-edit-reception',
  templateUrl: './edit-reception.component.html',
  styleUrls: ['./edit-reception.component.css']
})
export class EditReceptionComponent implements OnInit {

  userModel: UserViewModel={
    adUserId:'',
    dealerId:'',
    dealerName:'',
    email:'',
    adEmail:'',
    isActive:false,
    landline:0,
    mobile:0,
    mobileCode:'',
    roleId:0,
    roleName:'',
    userId:'',
    userName:'',
    functionCode:'',
    functionCodeDescription:'',
    locationCode:'',
    locationName:'',
    isEditable:false
  };
  editUserForm: FormGroup;
  dealerList: Array<SelectListItemViewModel>;
  dealerListSingleSelection: Array<SelectListItemViewModel>;
  userMobileCode: string;
  roleList: UserRoleViewModel[];
  receptionRole:boolean=true;
  selectedItems=[]
  dropdownSettings = {};
  existingIsActiveStatus:boolean
  defaultDealerOptions: Array<SelectListItemViewModel> = [];
  popupCloseResult = false;
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  
  constructor(
    private readonly spinner: NgxSpinnerService,
    public dealerBusinessService: DealerBusinessService,
    private readonly receptionBusinessService: ReceptionService,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService,
    private readonly formBuilder: FormBuilder,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly cdref: ChangeDetectorRef,
    private readonly userService: UserDataService,
    private readonly rolesRightsService: RolesRightsService,
    private readonly activeModal : NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly settingService: SettingService
  ) { }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search here',
      maxHeight: 500,
      enableCheckAll:false
    };
  this.receptionBusinessService.isEdit = true;
  this.initializeForm();
      this.getUserDetail();
  }


  async getUserDetail()
  {
    this.getUserDealers();
    await this.receptionBusinessService.getUserDetail(this.receptionBusinessService.userId).then(result => {
      if (result) {
        if(result.errorCount)
        {
          let errorMessage = this.translate.instant("lblUserNotFound");
          this.toaster.error(errorMessage);
        }
        else{ this.userModel = result.responseObject}
        if (this.userModel) {
          this.editUserForm.patchValue({
            ...this.userModel,
            name:this.userModel.userName,
            adEmail:this.userModel.adEmail,
          })
          this.existingIsActiveStatus=this.userModel.isActive;
          this.telInputObject();
        }
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
    }

    initializeForm()
    {
      this.editUserForm = this.formBuilder.group({
        roleId:['',[Validators.required]],
        dealerId: [''],
        name: [{value: '', disabled: true}, [Validators.required]],
        landline: ['', [Validators.pattern(/^\d{8,10}$/)]],
        mobile: ['', [Validators.required]],
        adEmail: ['', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)]],
        isActive: [true],
        adUserId: [null, [Validators.required]],
        dealerIds: [[]],
        defaultDealerId:['',[Validators.required]],
      });
      this.cdref.detectChanges();
    }

    async getUserDealers(){
      this.spinner.show();
      await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
          this.dealerList = this.mapdealer(response.userDealersModel,false);
          this.dealerListSingleSelection = this.mapdealer(response.userDealersModel,true);
          this.getRoleList();
      })
      this.spinner.hide();
    }

    mapdealer(array: UserDealersModel[],singleSelection:boolean){
      let supperArray = [];
      if (array && array.length > 0) {
        if(!singleSelection)
        {
          let single = Object();
          single.value = '-1'
          single.text = 'All'

          supperArray.push(single);
        }
        array.forEach(element=>{ 
          let single = Object();
          single.value = element.dealerId
          single.text = element.dealerName

          supperArray.push(single);
        })
      }
      return supperArray;
    }


    getRoleList()
    {
      this.cdref.detectChanges();
      this.spinner.show();
      this.rolesRightsService.getRoleList().then(response => {
        if (response) {
         this.roleList=response.responseObject.result;
         let currentUserPriority=this.roleList.filter(x=>x.id===this.userService.currentUserValue.roleType)[0]?.priority;
          if(currentUserPriority)
          {
            this.roleList=this.roleList.filter(x=>x.priority>currentUserPriority);
          }
          this.spinner.hide();
          if (this.roleList && this.roleList.length > 0) {
            this.userModel.userId = this.receptionBusinessService.userDetails.userId;
            this.userModel.adUserId = this.receptionBusinessService.userDetails.adUserId;
            this.userModel.roleId = this.receptionBusinessService.userDetails.roleId;
            this.userModel.adEmail = this.receptionBusinessService.userDetails.email;
            this.userModel.isActive = this.receptionBusinessService.userDetails.isActive;
            this.userModel.landline = this.receptionBusinessService.userDetails.landline;
            this.userModel.dealerId = this.receptionBusinessService.userDetails.dealerId;
            this.userModel.dealerName = this.receptionBusinessService.userDetails.dealerName;
            this.userModel.mobile = this.receptionBusinessService.userDetails.mobile;
            this.userModel.mobileCode = this.receptionBusinessService.userDetails.mobileCode;
            this.userModel.roleName = this.receptionBusinessService.userDetails.roleName;
            this.userModel.userName = this.receptionBusinessService.userDetails.userName;
            this.selectedItems = [];
            this.cdref.detectChanges();
            if(this.userModel.roleId === fromEnums.UserRoles.Reception)
            {
              this.receptionRole = true;
              this.editUserForm.patchValue({
                roleId: this.userModel.roleId,
                dealerId: this.userModel.dealerId,
                landline: this.userModel.landline,
                mobile: this.userModel.mobile,
                email: this.userModel.email,
                isActive: this.userModel.isActive,
                adUserId: this.userModel.adUserId,
                name:this.userModel.userName,
                adEmail:this.userModel.adEmail,
                defaultDealerId: this.userModel.defaultDealerId ?? this.userModel.dealerId,
              })
              this.refreshDefaultDealerOptions();
            }

            else{
              this.receptionRole = false;
              let dealer = this.userModel?.dealerId?.split(',');
              if(this.userModel.dealerId === "-1"){
                this.dealerList.forEach(x=>{
                  this.selectedItems.push(x);
                });
              }

              else{
                if(this.dealerList && dealer)
                {
                  this.dealerList.forEach(x=>{
                 dealer.forEach(y=>{
                   if(x.value===y){
                    this.selectedItems.push(x);
                   }
                 })
                })
                }
              }
              this.editUserForm.patchValue({
                roleId: this.userModel.roleId,
                dealerIds: this.selectedItems,
                landline: this.userModel.landline,
                mobile: this.userModel.mobile,
                email: this.userModel.email,
                isActive: this.userModel.isActive,
                adUserId: this.userModel.adUserId,
                name:this.userModel.userName,
                adEmail:this.userModel.adEmail,
                defaultDealerId: this.userModel.defaultDealerId,
              })
              this.refreshDefaultDealerOptions();
            }
            this.cdref.detectChanges();
            this.telInputObject();
          }
        }
        this.spinner.hide();
      });
    }

    get cpf() {
      return this.editUserForm.controls;
    }

    isDigit(event): void {
      const isDigit = Utility.isDigit(event);
      if (!isDigit) {
        event.preventDefault();
      }
    }

    onRoleSelected(_role:any)
    {
      if(this.editUserForm.controls.roleId.value === fromEnums.UserRoles.Reception)
      {
        let modelHeadermsg = this.translate.instant("lblRoleChange");
        let modelBodymsg = Utility.createMessage(this.translate.instant("lblRoleChangeToReceptionConfirmation"),' ',false);
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => { 
          //this is intentional
        }, (reason) => {
          this.popupCloseResult = this.getDismissReason(reason);
          if (this.popupCloseResult) {
            this.receptionRole = true;
          }
          else
          {
            this.editUserForm.patchValue({
              roleId:this.userModel.roleId
            })
          }
        });
      }
      else
      {
        this.receptionRole = false;
      }
    }

    private getDismissReason(reason: any): boolean {
      if (reason === ModalDismissReasons.ESC) {
        return false;
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return false;
      } else {
        return reason;
      }
    }

    onItemSelect(event)
    {    
      if(event.value==='-1')
      {
        this.selectedItems=[]
        this.dealerList.forEach(x=>{                  
             this.selectedItems.push(x);                  
         })
      }
        this.refreshDefaultDealerOptions();
    }

    onItemDeSelect(event)
    {
      if(event.value==='-1')
      {
        this.selectedItems=[]     
      }
      this.refreshDefaultDealerOptions();
    }

    private refreshDefaultDealerOptions() {
      if (this.receptionRole) {
        const match = this.dealerListSingleSelection?.find(d => d.value === this.editUserForm.get('dealerId')?.value);
        this.defaultDealerOptions = match ? [match] : [];
        if (!match) {
          this.editUserForm.get('defaultDealerId')?.setValue(null);
        } else if (!this.editUserForm.get('defaultDealerId')?.value) {
          this.editUserForm.get('defaultDealerId')?.setValue(match.value);
        }
      } else {
        const selectedValues: string[] = (this.editUserForm.get('dealerIds')?.value || []).map(x => x.value);
        const allSelected = selectedValues.includes('-1');
        if (allSelected) {
          this.defaultDealerOptions = this.dealerList?.filter(d => d.value !== '-1');
        } else {
          this.defaultDealerOptions = this.editUserForm.get('dealerIds')?.value.filter(d => d.value);
        }
        if (this.defaultDealerOptions?.length === 0) {
          this.editUserForm.get('defaultDealerId')?.setValue(null);
        } else {
          const current = this.editUserForm.get('defaultDealerId')?.value;
          if (!current || !this.defaultDealerOptions.some(d => d.value === current)) {
            this.editUserForm.get('defaultDealerId')?.setValue(this.defaultDealerOptions[0].value);
          }
        }
      }
      this.cdref.detectChanges();
    }

    onSubmit(): void {
      if (this.editUserForm.invalid) {
        return;
      }
      if(this.receptionRole)
      { 
          if(!this.editUserForm.get('dealerId').value)
            return;
      }
      else
      {
        if(this.editUserForm.get('dealerIds').value.length===0)
          return;
      }
      let dealerId;
      if(this.receptionRole){
       dealerId = this.editUserForm.get('dealerId').value
      }
      else{
        if(this.editUserForm.get('dealerIds').value.length === this.dealerList.length){
          dealerId = '-1'
        }
        else{
          dealerId = this.editUserForm.get('dealerIds').value.map(x=>x.value).join(',')
        }
      }
      const viewModel = {...this.editUserForm.value,
        email: this.cpf.adEmail.value.toString().toLowerCase(),
        dealerName:null,
        userId:this.userModel.userId,
        mobileCode: this.userMobileCode,
        dealerId:dealerId,
        name:this.cpf.name.value,
        mobile: this.cpf.mobile.value?.number ? this.cpf.mobile.value.number.toString().replace(/\s+/g, '') : this.cpf.mobile.value,
        existingIsActiveStatus:this.existingIsActiveStatus
      };
      this.spinner.show();
      let successmsg = this.translate.instant('lblUserUpdated');
      let errormsg = this.translate.instant('lblUpdateUserFail');
      let emailError=this.translate.instant('lblAdEmailAlreadyExists');
      let adUserError=this.translate.instant('lblAdGUIDAlreadyExists');
      let userLimitError = this.translate.instant('lblUserCreationLimitExceed');
        this.receptionBusinessService.addUpdateUser(viewModel).then((response) => {
            this.spinner.hide();
            let result = response.responseObject;
            if (result) {
                if (result.errorCount && result.errorCount > 0) {
                    let errorResponse = result.result;
                    if (errorResponse.errorCode === fromEnums.ErrorCodes.EmailAlreadyExistsErrorCode) {
                        this.toaster.error(emailError);
                    }
                    if (errorResponse.errorCode === fromEnums.ErrorCodes.AdUserIdAlreadyExistsErrorCode) {
                      this.toaster.error(adUserError);
                  }
                  if(errorResponse.errorCode === fromEnums.ErrorCodes.UserCreationLimitExceed){
                    this.toaster.error(userLimitError);
                  }
                } else {
                    this.toaster.success(successmsg);
                    this.activeModal.close({ success: true });
                }
            } else {
                this.toaster.error(errormsg);
            }
        });


    }

    telInputObject() {
      if(this.userModel?.mobileCode)
      {
        let countryCode = this.getCountryCodeByDialCode(this.userModel.mobileCode);
        this.selectedCountryISO= countryCode?countryCode:this.cultureLocaleService.getLocale();
      }
      else
      {
        this.selectedCountryISO= this.cultureLocaleService.getLocale();
      }
    }

    getCountryCodeByDialCode(dialCode: any) {
      const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
      return country ? country.countryCode : null;
    }

    onCountryChange(obj) {
      if (this.isInitialLoad) {
      this.telInputObject();
      this.userMobileCode = this.userMobileCode || obj.dialCode;
      this.isInitialLoad = false;
      } else {
        this.userMobileCode = obj.dialCode;
      }
    }
  OnClose(){
    this.activeModal.close({ success: true });
  }
  onMobileNoChange(){
    if(this.editUserForm.get('mobile').value){
      let len= this.editUserForm.get('mobile').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>11){
        this.editUserForm.get('mobile').setValidators([Validators.required, Validators.pattern(/^\d{8,11}$/)]);
        this.editUserForm.get('mobile').updateValueAndValidity();
      } else {
        this.editUserForm.get('mobile').setValidators([Validators.required]);
        this.editUserForm.get('mobile').updateValueAndValidity();
      }
    }
  }

}